const actionTypes = {
    CUSTOMER_INFO_SET: 'CUSTOMER_INFO_SET',
    CUSTOMER_INFO_FETCHING_SET: 'CUSTOMER_INFO_FETCHING_SET',

    COINSURED_INFO_SET: 'COINSURED_INFO_SET',
    COINSURED_INFO_FETCHING_SET: 'COINSURED_INFO_FETCHING_SET',

    CUSTOMER_CHILDREN_FETCHING_SET: 'CUSTOMER_CHILDREN_FETCHING_SET',
    CUSTOMER_CHILDREN_SET: 'CUSTOMER_CHILDREN_SET',

    CUSTOMER_ANIMALS_FETCHING_SET: 'CUSTOMER_ANIMALS_FETCHING_SET',
    CUSTOMER_ANIMALS_SET: 'CUSTOMER_ANIMALS_SET',
}

export default actionTypes;
